(() => {
  'use strict';

  const VERSION = '2026-09-29-v6-lower-routine-links';
  const ROUTINE_PAIRS = {
    'simple-acne-routine': 'clear-balanced-skin-routine',
    'simple-aging-skin-routine': 'firm-smooth-skin-routine',
    'simple-combination-skin-routine': 'combination-skin-balance-routine',
    'simple-dry-routine': 'dry-dehydrated-skin-routine',
    'simple-dull-skin-routine': 'glow-radiance-routine',
    'simple-daily-skincare-routine': 'normal-balanced-skin-routine',
    'simple-oily-skin-routine': 'oily-skin-routine',
    'simple-sensitive-skin-routine': 'sensitive-reactive-skin-routine'
  };
  const PAIRED_ROUTINE_LABELS = {
    en: {
      full: { hint: 'A more complete routine for your skin goals', action: 'Click here for the full routine' },
      simple: { hint: 'Easy daily care in just 2 steps', action: 'Click here for the simple routine' }
    },
    nl: {
      full: { hint: 'Uitgebreidere verzorging voor jouw huidtype', action: 'Klik hier voor de complete routine' },
      simple: { hint: 'Makkelijke dagelijkse verzorging in 2 stappen', action: 'Klik hier voor de eenvoudige routine' }
    },
    de: {
      full: { hint: 'Umfassendere Pflege für deinen Hauttyp', action: 'Hier zur vollständigen Routine' },
      simple: { hint: 'Einfache tägliche Pflege in nur 2 Schritten', action: 'Hier zur einfachen Routine' }
    },
    fr: {
      full: { hint: 'Une routine plus complète pour votre peau', action: 'Cliquez ici pour la routine complète' },
      simple: { hint: 'Des soins quotidiens simples en 2 étapes', action: 'Cliquez ici pour la routine simple' }
    }
  };

  const LABELS = {
    en: {
      overview: 'Why this routine', products: 'products', saving: 'you save', period: 'Morning & evening', daily: 'daily use',
      shippingNl: 'Free shipping in the Netherlands from €59.95', shippingEu: 'Free shipping in Europe from €90',
      add: 'Add routine to cart', buy: 'Buy now', assurance: 'Secure payment',
      payment: 'iDEAL, Klarna or card · VAT included', returns: '14-day withdrawal period for unopened products',
      fallbackKicker: 'A coordinated routine for daily care',
      fallbackBenefits: ['Products selected to work well together', 'Clear steps for morning and evening', 'A complete routine in one set']
    },
    nl: {
      overview: 'Waarom deze routine', products: 'producten', saving: 'jouw voordeel', period: 'Ochtend & avond', daily: 'dagelijks gebruik',
      shippingNl: 'Gratis verzending in Nederland vanaf €59,95', shippingEu: 'Gratis verzending in Europa vanaf €90',
      add: 'Voeg routine toe', buy: 'Direct bestellen', assurance: 'Veilig betalen',
      payment: 'iDEAL, Klarna of kaart · Prijs inclusief btw', returns: '14 dagen bedenktijd op ongeopende producten',
      fallbackKicker: 'Een complete routine voor dagelijkse verzorging',
      fallbackBenefits: ['Producten geselecteerd om goed samen te werken', 'Duidelijke stappen voor ochtend en avond', 'Een complete routine in één set']
    },
    de: {
      overview: 'Warum diese Routine', products: 'Produkte', saving: 'Sie sparen', period: 'Morgens & abends', daily: 'tägliche Anwendung',
      shippingNl: 'Kostenloser Versand in die Niederlande ab 59,95 €', shippingEu: 'Kostenloser Versand in Europa ab 90 €',
      add: 'Routine in den Warenkorb', buy: 'Jetzt kaufen', assurance: 'Sicher bezahlen',
      payment: 'Klarna oder Karte · MwSt. inklusive', returns: '14 Tage Widerrufsrecht für ungeöffnete Produkte',
      fallbackKicker: 'Eine abgestimmte Routine für die tägliche Pflege',
      fallbackBenefits: ['Produkte, die gut zusammenpassen', 'Klare Schritte für morgens und abends', 'Eine vollständige Routine in einem Set']
    },
    fr: {
      overview: 'Pourquoi cette routine', products: 'produits', saving: 'économisés', period: 'Matin & soir', daily: 'utilisation quotidienne',
      shippingNl: 'Livraison offerte aux Pays-Bas dès 59,95 €', shippingEu: 'Livraison offerte en Europe dès 90 €',
      add: 'Ajouter la routine', buy: 'Acheter maintenant', assurance: 'Paiement sécurisé',
      payment: 'Klarna ou carte · TVA incluse', returns: 'Délai de rétractation de 14 jours pour les produits non ouverts',
      fallbackKicker: 'Une routine coordonnée pour les soins quotidiens',
      fallbackBenefits: ['Des produits sélectionnés pour bien fonctionner ensemble', 'Des étapes claires matin et soir', 'Une routine complète dans un seul coffret']
    }
  };

  const ROUTINE_DATA = {
    'clear-balanced-skin-routine': { count: 3, saving: '14.90' },
    'firm-smooth-skin-routine': { count: 4, saving: '19.85' },
    'combination-skin-balance-routine': { count: 3, saving: '9.90' },
    'dry-dehydrated-skin-routine': { count: 4, saving: '19.85' },
    'glow-radiance-routine': { count: 3, saving: '14.90' },
    'normal-balanced-skin-routine': { count: 3, saving: '14.90' },
    'oily-skin-routine': { count: 3, saving: '9.90' },
    'sensitive-reactive-skin-routine': { count: 3, saving: '14.90' },
    'simple-acne-routine': { count: 2, saving: '9.95' },
    'simple-aging-skin-routine': { count: 2, saving: '9.95' },
    'simple-combination-skin-routine': { count: 2, saving: '9.95' },
    'simple-dry-routine': { count: 2, saving: '9.95' },
    'simple-dull-skin-routine': { count: 2, saving: '9.95' },
    'simple-daily-skincare-routine': { count: 2, saving: '9.95' },
    'simple-oily-skin-routine': { count: 2, saving: '9.95' },
    'simple-sensitive-skin-routine': { count: 2, saving: '9.95' }
  };

  const getLocale = () => {
    const code = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return LABELS[code] ? code : 'en';
  };
  const getHandle = () => window.location.pathname.replace(/\/+$/, '').split('/').pop() || '';
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const escapeHtml = (value) => {
    const node = document.createElement('span');
    node.textContent = String(value || '');
    return node.innerHTML;
  };
  const money = (value, locale) => {
    const amount = Number(value || 0);
    if (!Number.isFinite(amount) || amount <= 0) return '';
    return locale === 'nl' || locale === 'de' ? `€${amount.toFixed(2).replace('.', ',')}` : `€${amount.toFixed(2)}`;
  };

  const splitIntro = (intro, labels) => {
    const text = clean(intro);
    if (!text) return { kicker: labels.fallbackKicker, body: '' };
    const match = text.match(/^(.+?[.!?])(?:\s+|$)(.*)$/);
    if (!match || !clean(match[2])) return { kicker: labels.fallbackKicker, body: text };
    return { kicker: clean(match[1]), body: clean(match[2]) };
  };

  const extractBenefits = (root, labels) => {
    if (!root) return labels.fallbackBenefits;
    const headings = [...root.querySelectorAll('h2,h3,h4,strong')];
    const heading = headings.find((item) => /why you|why this|love it|voordelen|waarom|vorteile|pourquoi|benefits/i.test(clean(item.textContent)));
    let list = heading?.nextElementSibling;
    while (list && !/^(UL|OL|H2|H3|H4)$/.test(list.tagName)) list = list.nextElementSibling;
    const items = [...(list?.matches('ul,ol') ? list.querySelectorAll(':scope > li') : [])]
      .map((item) => clean(item.textContent)).filter(Boolean).slice(0, 3);
    if (items.length) return items;
    const firstList = [...root.querySelectorAll('li')]
      .map((item) => clean(item.textContent)).filter((item) => item.length > 8 && item.length < 180).slice(0, 3);
    return firstList.length ? firstList : labels.fallbackBenefits;
  };

  const descriptionCache = new Map();
  const fetchDescriptionBenefits = async (labels) => {
    const key = `${getLocale()}:${getHandle()}`;
    if (descriptionCache.has(key)) return descriptionCache.get(key);
    try {
      const response = await fetch(`${window.location.pathname}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('product-json-unavailable');
      const product = await response.json();
      const template = document.createElement('template');
      template.innerHTML = product.description || '';
      const benefits = extractBenefits(template.content, labels);
      descriptionCache.set(key, benefits);
      return benefits;
    } catch (_) {
      descriptionCache.set(key, labels.fallbackBenefits);
      return labels.fallbackBenefits;
    }
  };

  const parseLiveSaving = (locale) => {
    const text = clean(document.querySelector('main .sovah-savings')?.textContent);
    if (!text) return '';
    const values = [...text.matchAll(/€\s?([0-9]+(?:[.,][0-9]{1,2})?)/g)]
      .map((match) => Number(match[1].replace(',', '.'))).filter(Number.isFinite);
    if (values.length >= 2 && values[0] > values[1]) return money(values[0] - values[1], locale);
    return '';
  };

  const readStandards = () => {
    const data = window.SOVAH_CERT_DATA;
    const routine = data?.d?.[getHandle()];
    if (!routine || routine[0] !== 'b') return [];
    return routine[2].map((key) => data.a?.[key]?.[0]).filter(Boolean);
  };

  const addStyles = () => {
    if (document.getElementById('sovah-routine-combined-styles')) return;
    const style = document.createElement('style');
    style.id = 'sovah-routine-combined-styles';
    style.textContent = `
      .sovah-routine-combined-card{margin:.35rem 0 1.15rem;padding:1.3rem;border:1px solid color-mix(in srgb,#368582 58%,transparent);border-radius:1rem;background:color-mix(in srgb,#368582 9%,transparent)}
      .sovah-routine-combined-card__eyebrow{margin:0 0 .5rem;font-size:.76rem;font-weight:800;letter-spacing:.11em;text-transform:uppercase;opacity:.78}
      .sovah-routine-combined-card__kicker{margin:0;color:#6fc2bd;font-size:1rem;font-weight:750;line-height:1.35}
      .sovah-routine-combined-card__body{margin:.55rem 0 0;line-height:1.55}
      .sovah-routine-combined-card__benefits{display:grid;gap:.48rem;margin:.9rem 0;padding:0;list-style:none}
      .sovah-routine-combined-card__benefits li{position:relative;padding-left:1.45rem;line-height:1.45}
      .sovah-routine-combined-card__benefits li::before{content:'✓';position:absolute;left:0;color:#6fc2bd;font-weight:900}
      .sovah-routine-combined-card__stats{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:.55rem;margin-top:1rem}
      .sovah-routine-combined-card__stats>div{display:grid;align-content:center;min-height:4.25rem;padding:.7rem;text-align:center;border-radius:.65rem;background:color-mix(in srgb,currentColor 6%,transparent)}
      .sovah-routine-combined-card__stats strong,.sovah-routine-combined-card__stats span{display:block}
      .sovah-routine-combined-card__stats strong{font-size:.95rem;line-height:1.2}
      .sovah-routine-combined-card__stats span{margin-top:.24rem;font-size:.72rem;opacity:.68}
      .sovah-routine-combined-card__badges{display:flex;flex-wrap:wrap;gap:.5rem;margin-top:.9rem}
      .sovah-routine-combined-card__badges span{display:inline-flex;align-items:center;gap:.4rem;width:fit-content;padding:.4rem .65rem;border:1px solid color-mix(in srgb,currentColor 32%,transparent);border-radius:.5rem;font-size:.76rem;font-weight:750;line-height:1.25}
      .sovah-routine-combined-card__badges b{color:#ff7b55}
      .sovah-routine-combined-card__standards{margin:.85rem 0 0;padding-top:.75rem;border-top:1px solid color-mix(in srgb,currentColor 15%,transparent);font-size:.78rem;font-weight:700}
      main .sovah-routine-primary-buy{background:#368582!important;border-color:#368582!important;color:#fff!important;box-shadow:0 .5rem 1.25rem rgba(54,133,130,.18);font-weight:750}
      main .sovah-routine-primary-buy:hover{background:#2e736f!important;border-color:#2e736f!important;transform:translateY(-1px)}
      .sovah-routine-assurance{margin:-.45rem 0 1rem;padding:.85rem 1rem;border:1px solid color-mix(in srgb,currentColor 15%,transparent);border-left:3px solid #368582;border-radius:.75rem;background:color-mix(in srgb,#368582 6%,transparent);font-size:.78rem;line-height:1.5}
      .sovah-routine-assurance strong,.sovah-routine-assurance span{display:block}
      .sovah-routine-assurance span{margin-top:.18rem;opacity:.76}
      .sovah-routine-assurance strong::before{content:'✓';display:inline-grid;place-items:center;width:1.15rem;height:1.15rem;margin-right:.42rem;border-radius:50%;background:#368582;color:#fff;font-size:.7rem}
      @media(max-width:749px){.sovah-routine-combined-card{padding:1rem;border-radius:.85rem}.sovah-routine-combined-card__stats{grid-template-columns:1fr}.sovah-routine-combined-card__stats>div{min-height:auto;grid-template-columns:auto 1fr;justify-content:start;align-items:baseline;gap:.45rem;text-align:left}.sovah-routine-combined-card__stats span{margin:0}.sovah-routine-combined-card__badges span{width:100%;justify-content:center}}
    `;
    document.head.appendChild(style);
  };

  const renderCard = async (intro, labels) => {
    const buttons = document.querySelector('main .buy-buttons-block');
    if (!buttons?.parentElement) return;
    const copy = splitIntro(intro.textContent, labels);
    const routine = ROUTINE_DATA[getHandle()] || {};
    const locale = getLocale();
    const country = document.querySelector('[data-sovah-free-shipping-country]')?.dataset.sovahFreeShippingCountry || '';
    const count = Number(intro.dataset.sovahRoutineCount || 0) || routine.count || 0;
    const saving = clean(intro.dataset.sovahRoutineSaving) || parseLiveSaving(locale) || money(routine.saving, locale);
    const standards = readStandards();
    const initialBenefits = labels.fallbackBenefits;

    let card = document.querySelector('main [data-sovah-routine-combined-card]');
    if (!card) {
      card = document.createElement('section');
      card.className = 'sovah-routine-combined-card';
      card.dataset.sovahRoutineCombinedCard = VERSION;
      buttons.parentElement.insertBefore(card, buttons);
    }

    const currentHandle = getHandle();
    const isSimple = Object.hasOwn(ROUTINE_PAIRS, currentHandle);
    const pairedHandle = isSimple
      ? ROUTINE_PAIRS[currentHandle]
      : Object.keys(ROUTINE_PAIRS).find((simple) => ROUTINE_PAIRS[simple] === currentHandle);
    if (pairedHandle) {
      let link = document.querySelector('main .sovah-routine-switch');
      if (!link) {
        link = document.createElement('a');
        link.className = 'sovah-routine-switch';
      }
      const details = buttons.closest('.product-details');
      const accordions = details ? [...details.querySelectorAll('.accordion')] : [];
      const placement = accordions.at(-1) || card;
      placement.insertAdjacentElement('afterend', link);
      const localePrefix = window.location.pathname.split('/products/')[0] || '';
      link.href = `${localePrefix}/products/${pairedHandle}`;
      const pairedCopy = PAIRED_ROUTINE_LABELS[locale]?.[isSimple ? 'full' : 'simple']
        || PAIRED_ROUTINE_LABELS.en[isSimple ? 'full' : 'simple'];
      if (!link.querySelector('.sovah-routine-switch__content')) {
        link.innerHTML = '<span class="sovah-routine-switch__media"><img loading="lazy" alt=""></span><span class="sovah-routine-switch__content"><span class="sovah-routine-switch__hint"></span><strong class="sovah-routine-switch__action"></strong></span>';
      }
      link.querySelector('.sovah-routine-switch__hint').textContent = pairedCopy.hint;
      link.querySelector('.sovah-routine-switch__action').textContent = pairedCopy.action;
      link.setAttribute('aria-label', `${pairedCopy.hint}. ${pairedCopy.action}`);
      if (link.dataset.imageHandle !== pairedHandle) {
        link.dataset.imageHandle = pairedHandle;
        fetch(`${localePrefix}/products/${pairedHandle}.js`)
          .then((response) => response.ok ? response.json() : null)
          .then((product) => {
            if (!product?.featured_image) return;
            const img = link.querySelector('.sovah-routine-switch__media img');
            if (img) {
              img.src = product.featured_image;
              img.alt = product.title || '';
            }
          })
          .catch(() => { link.dataset.imageHandle = ''; });
      }
    }

    const paint = (benefits) => {
      const currentStandards = readStandards();
      card.innerHTML = `
        <p class="sovah-routine-combined-card__eyebrow">${escapeHtml(labels.overview)}</p>
        <p class="sovah-routine-combined-card__kicker">${escapeHtml(copy.kicker)}</p>
        ${copy.body ? `<p class="sovah-routine-combined-card__body">${escapeHtml(copy.body)}</p>` : ''}
        <ul class="sovah-routine-combined-card__benefits">${benefits.map((item) => `<li>${escapeHtml(item)}</li>`).join('')}</ul>
        <div class="sovah-routine-combined-card__stats">
          <div><strong>${count || '—'}</strong><span>${escapeHtml(labels.products)}</span></div>
          ${saving ? `<div><strong>${escapeHtml(saving)}</strong><span>${escapeHtml(labels.saving)}</span></div>` : ''}
          <div><strong>${escapeHtml(labels.period)}</strong><span>${escapeHtml(labels.daily)}</span></div>
        </div>
        <div class="sovah-routine-combined-card__badges"><span><b aria-hidden="true">⚡</b>${escapeHtml(country === 'NL' ? labels.shippingNl : labels.shippingEu)}</span></div>
        ${currentStandards.length ? `<p class="sovah-routine-combined-card__standards">${currentStandards.map(escapeHtml).join(' · ')}</p>` : ''}
      `;
    };

    paint(initialBenefits);
    intro.hidden = true;
    const oldSavings = document.querySelector('main .sovah-savings');
    if (oldSavings) oldSavings.hidden = true;
    const benefits = await fetchDescriptionBenefits(labels);
    paint(benefits);
  };

  const renderPurchase = (labels) => {
    const addButton = document.querySelector('main .add-to-cart-button');
    const addText = addButton?.querySelector('.add-to-cart-text__content');
    const buyButton = document.querySelector('main .shopify-payment-button__button--unbranded');
    if (addText && addButton && !addButton.disabled) addText.textContent = labels.add;
    if (addButton && !addButton.disabled) {
      addButton.classList.add('sovah-routine-primary-buy');
      addButton.setAttribute('aria-label', labels.add);
    }
    if (buyButton) buyButton.textContent = labels.buy;

    const buttons = document.querySelector('main .buy-buttons-block');
    if (!buttons?.parentElement) return;
    let assurance = document.querySelector('main .sovah-routine-assurance');
    if (!assurance) {
      assurance = document.createElement('div');
      assurance.className = 'sovah-routine-assurance';
      buttons.insertAdjacentElement('afterend', assurance);
    }
    assurance.innerHTML = `<strong>${escapeHtml(labels.assurance)}</strong><span>${escapeHtml(labels.payment)}</span><span>${escapeHtml(labels.returns)}</span>`;
  };

  let running = false;
  const render = async () => {
    if (running) return;
    const intro = document.querySelector('main .sovah-routine-intro');
    if (!intro || !ROUTINE_DATA[getHandle()]) return;
    running = true;
    try {
      const labels = LABELS[getLocale()];
      document.documentElement.dataset.sovahRoutineCombined = VERSION;
      addStyles();
      await renderCard(intro, labels);
      renderPurchase(labels);
    } finally {
      running = false;
    }
  };

  const schedule = () => [0, 150, 600, 1400].forEach((delay) => window.setTimeout(render, delay));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('shopify:section:load', schedule);
})();
